module.exports = __webpack_public_path__ + "img/voiceOverIcon.fd3877ab.svg";